<p>Paso {{ step()+1 }} de {{ steps().length }}</p>
<p class="capital-title">Validamos tu identidad</p>
@if (!errorStatus()) {
<div class="text-container">
    <p class="welcome-subtitle mb-0">{{ steps()[step()].subtitle }}</p>
</div>
<div class="d-flex justify-content-center align-items-center image-container mb-3">
    <img [src]="steps()[step()].image" alt="">
</div>
<p class="text-center status-text m-0">{{ status() }} <span class="dots d-inline-block text-start">{{dots()}}</span></p>
} @else {
<div class="text-center mt-5">
    <div class="my-alert d-inline-block text-start">
        <div class="row">
            <div class="col-1"> <img src="/img/info-transparent.svg" alt="" width="24px"></div>
            <div class="col ps-0">
                <p class="alert-title">{{ errorTitle() }}</p>
                <p class="alert-subtitle m-0">{{ errorExplanation() }}</p>
            </div>
        </div>
    </div>
    <p class="fw-bold mt-2">No logramos identificarte</p>
    <p>Por favor, vuelve a intentar el proceso de validación.</p>

    <div class="retry-button d-inline-block fw-bold" role="button" (click)="back()">Reintentar</div>
</div>
}